import { useEffect } from 'react';

declare global {
  export interface Window {
    OneTrust?: {
      ToggleInfoDisplay: () => void;
    };
  }
}

export const HASH_FOR_COOKIE_PREFERENCES = '#cookie-preferences';

export const useReopenCookiePreferences = () =>
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      if (event.target instanceof HTMLAnchorElement && event.target.hash === HASH_FOR_COOKIE_PREFERENCES) {
        event.preventDefault();
        window.OneTrust?.ToggleInfoDisplay();
      }
    };
    document.addEventListener('click', onClick);

    return () => document.removeEventListener('click', onClick);
  }, []);
